import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { NewMetricForDatasource } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface NewMetricForDatasourceAction extends Action {
  contentInfo: IContentInfo;
}

export function newMetricForDatasource(contentInfo: IContentInfo): NewMetricForDatasourceAction {
  return {
    type: NewMetricForDatasource,
    contentInfo
  };
}

export const isNewMetricForDatasourceAction = isActionFactory<NewMetricForDatasourceAction>(NewMetricForDatasource);
